var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('filters'),_c('a-input',{attrs:{"manual-doc":_vm.userDoc,"field":"routes.failures.search","label":_vm.$t('common.quick_search')}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }